<template>
    <aside class="main-sidebar">
      <!-- sidebar: style can be found in sidebar.less -->
      <section class="sidebar">
        <!-- sidebar menu: : style can be found in sidebar.less -->
        <ul class="sidebar-menu">
          <li class="header">MAIN NAVIGATION</li>


          <li class="treeview active" v-if="fullAdmin >= 30">
            <a href="#">
              <i class="fa fa-cogs"></i>
              <span>Servers</span>
              <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"></i>
            </span>
            </a>
            <ul class="treeview-menu">
              <li>
                <router-link to="/servers-data">
                  <i class="fa fa-circle-o"></i> <span>Informations</span>
                </router-link>
              </li>
              <li v-if="fullAdmin >= 40">
                <router-link to="/sql">
                  <i class="fa fa-circle-o"></i> <span>Execute SQL</span>
                </router-link>
              </li>

            </ul>
          </li>

          <li class="treeview active" v-if="fullAdmin >= 30">
            <a href="#">
              <i class="fa fa-user"></i>
              <span>User managment</span>
              <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"></i>
            </span>
            </a>
            <ul class="treeview-menu">
              <li>
                <router-link to="/users">
                  <i class="fa fa-circle-o"></i> <span>Users</span>
                </router-link>
              </li>


              <li v-if="fullAdmin >= 40">
                <router-link to="/all-info">
                  <i class="fa fa-circle-o"></i> <span>Search User</span>
                </router-link>
              </li>

              <li v-if="fullAdmin >= 33">
                <router-link to="/ban">
                  <i class="fa fa-circle-o"></i> <span>Ban</span>
                </router-link>
              </li>
              <li v-if="fullAdmin >= 30">
                <router-link to="/coins">
                  <i class="fa fa-circle-o"></i> <span>Coins</span>
                </router-link>
              </li>
              <li v-if="fullAdmin >= 30">
                <router-link to="/facebook-switch">
                  <i class="fa fa-circle-o"></i> <span>Facebook merge</span>
                </router-link>
              </li>
              <li v-if="fullAdmin >= 33">
                <a href="/analytic">
                  <i class="fa fa-google"></i> <span>Analytic</span>
                </a>
              </li>
              <li v-if="fullAdmin >= 40">
                <a href="/block-analytics">
                  <i class="fa fa-google"></i> <span>Block Analytic</span>
                </a>
              </li>

            </ul>
          </li>

          <li class="treeview active">
            <a href="#">
              <i class="fa fa-comments"></i>
              <span>Chats</span>
              <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"></i>
            </span>
            </a>
            <ul class="treeview-menu">
              <li v-if="fullAdmin >= 20">
                <router-link to="/chats/history">
                  <i class="fa fa-circle-o"></i> <span>Chat History</span>
                </router-link>
              </li>
              <li>
                <router-link to="/admin-chat">
                    <i class="fa fa-circle-o"></i> <span>Admin Chat</span>
                </router-link>
              </li>
              <li>
                <router-link to="/chats" v-if="fullAdmin >= 20">
                  <i class="fa fa-circle-o"></i> <span>Chats</span>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="treeview active">
            <a href="#">
              <i class="fa fa-picture-o"></i>
              <span>Skins</span>
              <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"></i>
            </span>
            </a>
            <ul class="treeview-menu">
              <li>
                <router-link to="/skins">
                  <i class="fa fa-circle"></i> <span>Skins</span>
                </router-link>
              </li>

              <li>
                <router-link to="/private-skins">
                  <i class="fa fa-circle"></i> <span>Private skins</span>
                </router-link>
              </li>

              <li>
                <router-link to="/skins-managment">
                  <i class="fa fa-circle-o"></i> <span>New skins <span class="label label-info">{{ $store.state.waitSkins }}</span></span>
                </router-link>
              </li>
              <li>
                <router-link to="/private-skins-managment">
                  <i class="fa fa-circle-o"></i> <span>New private skins <span class="label label-info">{{ $store.state.waitPrivateSkins }}</span></span>
                </router-link>
              </li>
              <!-- <li>
                <router-link to="/pending-skins">
                  <i class="fa fa-circle-o"></i> <span>Pending <span class="label label-info">{{ $store.state.waitPrivateSkins }}</span></span>
                </router-link>
              </li> -->

            </ul>
          </li>


        </ul>
      </section>
      <!-- /.sidebar -->
    </aside>
</template>

<script>
  export default {
    name: 'DashboardSidebar',
    data: function () {
      return {
        form: new Form({}),
        fullAdmin: 0
      }
    },
    mounted: function () {
      this.fullAdmin = Number(this.$store.state.role)
      var self = this
      this.form.post(baseUrl + 'Skins/numberOfWaitingSkins').then(function (result) {
        self.$store.commit('SET_SKINS', Number(result))
      }, function (reason) {
      })
      this.form.post(baseUrl + 'Skins/numberOfWaitingPrivateSkins').then(function (result) {
        self.$store.commit('SET_PRIVATE_SKINS', Number(result))
      }, function (reason) {
      })
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// Sidebar.vue?697354c1